import CirclePerson from '../src/CirclePerson';
export default CirclePerson;
